import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { AuthProvider } from "./contexts/AuthContext";
import TravelLayout from "./components/layout/TravelLayout";

// Travel Pages
import TravelHomePage from "./pages/TravelHomePage";
import ServicesPage from "./pages/ServicesPage";
import ConsultationPage from "./pages/ConsultationPage";
import ConsultationSuccessPage from "./pages/ConsultationSuccessPage";
import TravelResourcesPage from "./pages/TravelResourcesPage";
import AboutPage from "./pages/AboutPage";
import TravelContactPage from "./pages/TravelContactPage";

// Legacy Pages (Admin & Auth)
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminDashboard from "./pages/AdminDashboard";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed database and migrate categories on first load
    const initializeApp = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (error) {
        // Database already seeded or seed failed - this is expected
      }
      
      // Migrate categories for existing databases
      try {
        await axios.post(`${API}/migrate/categories`);
      } catch (error) {
        // Categories may already exist
      }
    };
    initializeApp();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Travel Site Pages */}
          <Route element={<TravelLayout><TravelHomePage /></TravelLayout>} path="/" />
          <Route element={<TravelLayout><ServicesPage /></TravelLayout>} path="/services" />
          <Route element={<TravelLayout><ConsultationPage /></TravelLayout>} path="/consultation" />
          <Route element={<TravelLayout><ConsultationSuccessPage /></TravelLayout>} path="/consultation/success" />
          <Route element={<TravelLayout><TravelResourcesPage /></TravelLayout>} path="/resources" />
          <Route element={<TravelLayout><AboutPage /></TravelLayout>} path="/about" />
          <Route element={<TravelLayout><TravelContactPage /></TravelLayout>} path="/contact" />
          
          {/* Auth Pages */}
          <Route element={<TravelLayout><LoginPage /></TravelLayout>} path="/login" />
          <Route element={<TravelLayout><RegisterPage /></TravelLayout>} path="/register" />
          
          {/* Admin Dashboard */}
          <Route element={<TravelLayout><AdminDashboard /></TravelLayout>} path="/admin" />
          
          {/* Legal Pages */}
          <Route element={<TravelLayout><TermsPage /></TravelLayout>} path="/terms" />
          <Route element={<TravelLayout><PrivacyPage /></TravelLayout>} path="/privacy" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
